import React ,{Component} from "react"
import axios  from "axios";
import { Autocomplete, responsiveFontSizes, TableCell, TableRow, TextField } from "@mui/material";
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import {NavLink, Navigate  } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import Paper from '@mui/material/Paper';  
import Table from '@mui/material/Table'; 
import TableContainer from '@mui/material/TableContainer';  
import TableHead from '@mui/material/TableHead';  
import { styled } from '@mui/system';
import TableSortLabel from '@mui/material/TableSortLabel'; 
import PropTypes from 'prop-types';
import TablePagination from '@mui/material/TablePagination';  
import TableBody from '@mui/material/TableBody';
//import { styled } from '@mui/material/styles';  
import EditIcon from '@mui/icons-material/Edit';
import Checkbox from '@mui/material/Checkbox'; 
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import Select from '@mui/material/Select';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import CheckIcon from '@mui/icons-material/Check';
import Dialog from '@mui/material/Dialog';      
import DialogActions from '@mui/material/DialogActions'; 
import DialogContent from '@mui/material/DialogContent'; 
import DialogTitle from '@mui/material/DialogTitle';   
import psdfimage from './images/psdfimage.png';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
const useToolbarStyles = styled(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  title: {
    flex: '1 1 100%',
  },
}));
const useStyles = styled(theme =>({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
form: {
    width: '500%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
	 minWidth: 120,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
   textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
})
)
export default class Chartofaccount  extends React.Component{
    constructor(props) {
    super();
    this.state={
      submitbtn:'Save',LedgerData:[],pagename:'',pdflogo:'',redirect:false,page:0,rowsPaging:[],rowsPerPage:30,CategoryData:[],le_category:'',le_ledgername:'',
      selectedCategoryName:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:20,rowsPaging:[],exportdata:[],selectcategory:'',category:'',openExportDialog: false, 
    }
     this.myChangeHandlerCat = this.myChangeHandlerCat.bind(this);
    }
  myChangeHandler = (event) => {
    alert(this.state.le_category)
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 }
componentWillMount() {
   	  if(localStorage.getItem("ISIuserid")==null)
		  {
		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
		if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {	
  this.apicall(this.state.page,this.state.rowsPerPage); 	  
		  }
		  else{	    
		this.PageAccessCheckApi();
         }
}
     this.props.parentdasCallback(
            "Chart of Accounts"
        ); 
  }
	PageAccessCheckApi() {
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=36')
  .then(resp => {
	  let strreturn=resp.data;
      if (strreturn!==0) {
  this.apicall(this.state.page,this.state.rowsPerPage); 
      } else {
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
  });
}
myChangeHandler = (event) => {
    let nam = event.target.name;
    let val =  event.target.value;
    this.setState({[nam]: val},()=>{});
}
myChangeHandlerCat = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const selectedIndex = event.target.selectedIndex;
    const selectedText = event.target.options[selectedIndex].text;
    this.setState({
        [name]: value,
        selectedCategoryName: selectedText
    }, () => {
        alert(this.state.selectedCategoryName);
    });
};
apicall(page,rowsPerPage){
axios.get(localStorage.getItem("ISIurl")+'ajaxledger.php?action=getall&StartIndex='+page+'&PageSize='+rowsPerPage+'&le_ledgername='+this.state.le_ledgername+'&le_category='+this.state.category)
  .then(resp => {  
		if(resp.data.length>0){
			this.setState({  
			  LedgerData: resp.data, 
               totaldata:parseInt(resp.data[0].count),
			});
		this.exportapicall();
	}
	 else{
		   this.setState({LedgerData:[],totaldata:0,exportdata:resp.data});
	 }
    });
}
exportapicall(page,rowsPerPage){
axios.get(localStorage.getItem("ISIurl")+'ajaxledger.php?action=getall&le_ledgername='+this.state.le_ledgername+'&le_category='+this.state.category)
  .then(resp => {  
		if(resp.data.length>0){
			this.setState({  
               exportdata:resp.data
			});
	}
	 else{
		   this.setState({LedgerData:[],totaldata:0,exportdata:resp.data});
	 }
    });
}
handleChangePage = (event, newPage) => {  
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
  };   
   handleChangeRowsPerPage = event => {  
    let pageval = event.target.value;
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
  };
handleClickSearch=()=>{
 this.apicall(this.state.page,this.state.rowsPerPage); 
} 
categoryChange = (event) => {
  const nam = event.target.name;
  const val = event.target.value;
  this.setState({ [nam]: val, selectcategory: val,  });
};
    handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };
    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    };
handleClickOpen = () => {
      this.GetLogoForpdf();
  };
GetLogoForpdf() {
  axios
    .get(`${localStorage.getItem("ISIurl")}ajaxbusinesssetting.php`, {
      params: {
        action: "getpdflogo",
        bs_cmp_id: localStorage.getItem("ISIcmpid"),
        bs_id: 2,bs_page:5
      },
    })
    .then((resp) => {
      if (resp.data.status === "success") {
        this.setState(
          {
            pdflogo: resp.data.base64,
          },
          () => {
            setTimeout(() => {
              this.handleDownload();
            }, 500);
          }
        );
      } else {
        console.error("Error:", resp.data.message);
      }
    })
    .catch((error) => {
      console.error("Request failed:", error);
    });
}
handleDownload = () => {
  const { exportdata } = this.state;
  const doc = new jsPDF();
 const pageWidth = doc.internal.pageSize.getWidth();
    const imgWidth = 45;
    const imgHeight = 20;
    const imgX = (pageWidth - imgWidth) / 2;
    const imgY = 10;
    if (this.state.pdflogo) {
	 const logoImage = this.state.pdflogo.startsWith('data:image')
      ? this.state.pdflogo
      : `data:image/jpeg;base64,${this.state.pdflogo}`;
  doc.addImage(logoImage, 'JPEG', imgX, imgY, imgWidth, imgHeight);
 }
  const title = "Chart of Accounts Report";
  doc.setFontSize(16);
  doc.text(title, doc.internal.pageSize.width / 2, 38, { align: "center" });
  const headers = [["Account Number", "Ledger Name", "Category", "Visible?"]];
  const rows = exportdata.map((item) => [
    item.le_code,
    item.le_ledgername,
    item.category,
    (
      item.le_isbank !== "0" ||
      item.le_issales !== "0" ||
      item.le_isexpenses !== "0" ||
      item.le_otherpayments !== "0" ||
      item.le_otherreciepts !== "0" ||
      item.le_journals !== "0"
    ) ? "✔" : "",
  ]);
  doc.autoTable({
    head: headers,
    body: rows,
    startY: 45,
    theme: "striped",
    styles: { fontSize: 10 },
    headStyles: { fillColor: [41, 128, 185], textColor: 255 },
    didDrawPage: function (data) {
      const page = doc.internal.getNumberOfPages();
      doc.setFontSize(10);
      doc.text(
        `Page ${page}`,
        doc.internal.pageSize.width / 2,
        doc.internal.pageSize.height - 10,
        { align: "center" }
      );
    },
  });
  doc.save("ChartOfAccounts.pdf");
};
render() {
  if(this.state.redirect===true){
     return <Navigate to={this.state.pagename} />
  }
return (
  <React.Fragment>
     <div className="searchboxcat">
    <ul>
     <li>
            <p>Search</p>
            <p>
              <TextField
                variant="outlined"
                fullWidth
                className="txtbox"
                value={this.state.le_ledgername}
                id="le_ledgername"
                inputProps={{ tabIndex: "1", maxLength: 150 }}
                name="le_ledgername"
                onChange={this.myChangeHandler}
                InputProps={{
                  endAdornment: (
                    <SearchOutlinedIcon style={{ marginLeft: 8 }} />
                  ),
                }}
              />
            </p>
          </li>
<li>
         <p>Category <span className="validation">*</span></p>				  
<p><FormControl >
		 <Select
         native fullWidth
		 variant="outlined"
          margin="normal"
          onChange={this.categoryChange}
          id="type"
		   value={this.state.category} inputProps={{tabIndex: "4",maxLength:25}} className="txtbox"
		  name="category"
		>
	      <option value="Select">Select Category</option>
          <option value={"BANK"}>Bank</option>
          <option value={"CREDIT_CARD_/_LOAN"}>Credit Card / Loan</option>
          <option value={"CURRENT_ASSETS"}>Current Assets</option>
		  <option value={"CURRENT_LIABILITY"}>Current Liability</option>
          <option value={"DEPRECIATION"}>Depreciation</option>
          <option value={"DIRECT_EXPENSES"}>Direct Expenses</option>
		  <option value={"EQUITY"}>Equity</option>
		  <option value={"FIXED_ASSETS"}>Fixed Assets</option>
          <option value={"FUTURE_ASSETS"}>Future Assets</option>
          <option value={"FUTURE_LIABILITY"}>Future Liability</option>
		  <option value={"OTHER_INCOME"}>Other Income</option>
          <option value={"OVERHEADS"}>Overheads</option>
          <option value={"SALES"}>Sales</option>
         </Select>
         </FormControl>
		</p>			
		</li>
    <li>
    <p>&nbsp;</p>
         <p className="searchbutton">
           <Button
      type="submit"
      variant="contained"
      className="frmSecondarybtn"
      onClick={this.handleClickSearch}
    >
      Search 
    </Button>
&nbsp;&nbsp;
	<Button variant="contained" color="primary" className="exportbtn" onClick={this.handleOpenExportDialog} 
                                >
                                    EXPORT
                                </Button></p>
    </li>
     </ul>
    </div>
     <div className="clear"></div>
<Paper className={useStyles.root}>
  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
	<TableHead>				<TableRow>
<TableCell>Account Number</TableCell>
<TableCell>Ledger Name</TableCell>	
<TableCell>Category</TableCell>		
<TableCell>Visible?</TableCell>					
			</TableRow>	</TableHead>
                      <TableBody>
                     {this.state.LedgerData.map((item,index) =>{
   return ( <React.Fragment>
 <TableRow key={index} >
<TableCell>{item.le_code}</TableCell>
<TableCell>{item.le_ledgername}</TableCell>
<TableCell>{item.category}</TableCell>
<TableCell>
  {(	
    item.le_isbank !== "0" ||
    item.le_issales !== "0" ||
    item.le_isexpenses !== "0" ||
    item.le_otherpayments !== "0" ||
    item.le_otherreciepts !== "0" ||
    item.le_journals !== "0"
  ) && <CheckIcon sx={{ color: 'green', fontSize: 24 }} />}
</TableCell>
 </TableRow>
				</React.Fragment>	
				);
				{this.state.LedgerData.length===0  &&(
				<TableRow  >
<TableCell colspan="5">
<h3>No Records</h3>
</TableCell>
				</TableRow>
				)}
					})}
                      </TableBody>
</Table>
  </TableContainer> 
 <TablePagination  
          rowsPerPageOptions={[5,10]} 
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage} />    
  </Paper>
<Table id="chart-of-accounts" style={{ display: 'none' }}>
	<TableHead>
	<TableRow>
			<TableCell>Account Number</TableCell>
			<TableCell>Ledger Name</TableCell>	
			<TableCell>Category</TableCell>		
			<TableCell>Visible?</TableCell>	
	</TableRow>
	</TableHead>
<TableBody>
	{this.state.exportdata.map((item, index) => (
                <TableRow key={index}>
		<TableCell>{item.le_code}</TableCell>
		<TableCell>{item.le_ledgername}</TableCell>
		<TableCell>{item.category}</TableCell>
		<TableCell>
		  {(
			item.le_isbank !== "0" ||
			item.le_issales !== "0" ||
			item.le_isexpenses !== "0" ||
			item.le_otherpayments !== "0" ||
			item.le_otherreciepts !== "0" ||
			item.le_journals !== "0"
		  ) ? "✔" : ""}
		</TableCell>
        </TableRow>
            ))}
        </TableBody>
    </Table>
 <Dialog open={this.state.openExportDialog} onClose={this.handleCloseExportDialog}>
                    <DialogTitle>Generate Chart of Account List</DialogTitle>
                    <DialogContent>
					<p> To generate a new report, based on the latest selection criteria you've specified, choose the format 
					you want to use. Depending on the amount of data included on the report, it may take some time to generate.</p>
					<p style={{ textAlign: "center", display: "flex", justifyContent: "center", gap: "20px" }}>
					<ReactHTMLTableToExcel
                                    variant="contained"
                                    color="primary"
                                    id="test-table-xls-button"
                                    className="my-custom-excel-button"
                                    table="chart-of-accounts"
                                    filename="Chart of Account"
                                    sheet="Chart of Account"
                                    buttonText=""
                                />
                         <img
    src={psdfimage}
    width={100}
    height={100}
    style={{ cursor: "pointer" }}
    onClick={this.handleClickOpen}
    alt="Download PDF"
  />
						</p>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseExportDialog} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
  </React.Fragment>
);
}
}